<template>
  <div>
    <div v-show="!isEmpty" ref="pieChart" style="height: 500px;"></div>
    <Empty style="border:none" v-show="isEmpty" tips="图表暂无数据哦～" />
  </div>
</template>

<script>
import echarts from 'echarts';
import cloneDeep from 'lodash/cloneDeep';
import accounting from 'accounting';
import { Empty } from '@/components';

export default {
  name: 'PieChart',
  components: {
    Empty
  },
  props: {
    chartData: {
      type: Object,
      default: null
    },
    dimension: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      chartOptions: {
        tooltip: {
          trigger: 'item',
          formatter: params => {
            let value = accounting.formatNumber(params.value);
            return `${params.name} <br/>${params.seriesName}: ${value} (${params.percent}%)`;
          }
        },
        legend: {
          type: 'scroll',
          orient: 'horizontal',
          left: 'left',
          top: 24,
          data: []
        },
        series: []
      },
      chart: null
    };
  },
  watch: {
    chartData: {
      immediate: true,
      handler(info) {
        if (!info) return;
        this.renderChart();
      }
    },
    dimension: {
      immediate: true,
      handler(info) {
        if (!this.chartData) return;
        this.renderChart();
      }
    }
  },
  computed: {
    isEmpty() {
      return !this.chartData || this.chartData.data.list.length < 1;
    }
  },
  methods: {
    renderChart() {
      if (this.isEmpty) return;
      let targetName = this.dimension.label;
      let chartData = this.chartData.data.list;
      let total = this.chartData.data.total;
      let options = cloneDeep(this.chartOptions);
      options.title = [
        {
          text: targetName,
          textStyle: {
            fontSize: 16,
            color: 'black'
          },
          top: 68,
          left: '2%'
        },
        {
          text: targetName,
          subtext: accounting.formatNumber(total[this.dimension.value]),
          textStyle: {
            fontSize: 20,
            color: 'black'
          },
          subtextStyle: {
            fontSize: 20,
            color: 'black'
          },
          textAlign: 'center',
          textVerticalAlign: 'middle',
          left: '50%',
          top: '46%'
        }
      ];
      let legends = chartData.map(item => item.name);
      options.legend.data = legends;
      let seriesData = chartData.map(item => {
        return {
          value: item[this.dimension.value],
          name: item.name
        };
      });
      let series = {
        name: targetName,
        type: 'pie',
        radius: ['50%', '70%'],
        avoidLabelOverlap: false,
        label: {
          normal: {
            show: true,
            position: 'outer',
            formatter: params => {
              // TODO: 王媛大脑袋的要求, 饼图小于百分5的不展示文本
              return params.percent < 5 ? '' : params.name;
            }
          },
          emphasis: {
            show: true,
            textStyle: {
              fontSize: '30',
              fontWeight: 'bold'
            }
          }
        },
        labelLine: {
          normal: {
            show: false
          }
        },
        data: seriesData
      };
      options.series = [series];
      this.$nextTick(() => {
        if (!this.chart) {
          this.chart = echarts.init(this.$refs['pieChart']);
        }
        this.chart.setOption(options);
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
